import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { useApp } from '../../hooks/useApp';

export default function ToastNotification() {
  const { toast } = useApp();

  return (
    <Box
      position="fixed"
      bottom={7}
      right={7}
      zIndex={500}
      bg="#0e1a2a"
      border="1px solid rgba(0,195,255,0.35)"
      color="#f0f0f5"
      p="14px 22px"
      borderRadius="12px"
      fontSize="0.88rem"
      display="flex"
      alignItems="center"
      gap={2.5}
      opacity={toast ? 1 : 0}
      transform={toast ? 'translateY(0)' : 'translateY(16px)'}
      transition="all 0.35s"
      pointerEvents="none"
      boxShadow="0 8px 32px rgba(0,0,0,0.5)"
      maxW="340px"
    >
      {toast?.emoji && <Text fontSize="1rem">{toast.emoji}</Text>}
      <Text>{toast?.message}</Text>
    </Box>
  );
}
